export default __webpack_public_path__ + "static/media/about.bbc0b4be.jpg";